export const LIVE_ONE_DAY_RETURN_COLUMN_META_VALUE_FIELD =
  'latest_1D_return.value';
